class MenuPanel extends Panel {
  connectedCallback() {
    super.connectedCallback();
    this.desktopNav = this.querySelector('desktop-nav-drawer');
    this.mobileNav = this.querySelector('mobile-nav-drawer');
  }

  escape(e) {
    let target = window.matchMedia('(min-width: 1199px)').matches ? this.desktopNav : this.mobileNav;
    target.escape();
    // if (e.detail.triggerElement) {
    //   console.log('focus', e.detail.triggerElement);
    //   e.detail.triggerElement.focus();
    // }
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    let target = window.matchMedia('(min-width: 1199px)').matches ? this.desktopNav : this.mobileNav;
    target.activate();
    requestAnimationFrame(() => {
      switch (previousState) {
        case 'idle':
          target.onDrawerTriggerClick(triggerElement);
          drawerElement.addEventListener('mouseover', mouseOverDrawer); // @todo - what
          this.animateDrawOpen().then(() => {
            target.focusLevelOne(triggerElement);
          });
          break;
        case 'shopActive':
          target.onDrawerTriggerClick(triggerElement);
          break;
        case 'searchActive':
        default:
          target.onDrawerTriggerClick(triggerElement);
          if (previousPanel) {
            previousPanel.deactivate();
          }
          break;
      }
    });
  }

  animateDrawOpen() {
    console.log('openLeftNav');

    return new Promise((resolve) => {
      header.classList.add('desktop-drawer-open');
      maskElement.show();
      // set start state
      drawerElement.className =
        'drawer-inner transition-all absolute inset-y-0 z-75 w-24 lg:w-25 -translate-x-full bg-white duration-600 md:group-[.level-2-active]:w-27 lg:group-[.level-2-active]:w-28 2xl:group-[.level-2-active]:w-29';
      // un-hide container
      drawerWrapperElement.classList.remove('hidden');
      // set transition state
      requestAnimationFrame(() => {
        maskElement.classList.replace('opacity-0', 'opacity-60');
        drawerElement.classList.remove('-translate-x-full');
        waitForTransitionEnd(drawerElement).then(() => {
          resolve();
        });
      });
    });
  }
}
customElements.define('menu-panel', MenuPanel);
